import { CloseIcon, EditIcon, ViewIcon } from '@chakra-ui/icons';
import {
    Avatar,
    Badge,
    Box,
    Button,
    Card,
    Center,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    HStack,
    Icon,
    IconButton,
    Input,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    SimpleGrid,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    useDisclosure,
    useToast,
    VStack
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { FaBook, FaClock, FaCloudUploadAlt, FaLongArrowAltDown, FaMapMarkerAlt, FaPaperclip, FaPrint, FaStickyNote, FaSync, FaTasks, FaUserCheck } from 'react-icons/fa';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { exportPickups, fetchAllCouriers, fetchFacilitiesBySearch, fetchLabLocations, getAllPickups, searchPickups, updatePickup, uploadPickupAttachements } from '../../api';
import AccessDenied from '../../components/AccessDenied';
import Loading from '../../components/Loading/Loading';
import Pagination from '../../components/Pagination';
import PopoverId from '../../components/PopoverId';
import TitleHeader from '../../components/TitleHeader';

import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ImageLightbox from '../../components/ImageLightBox';
import PickupImageLightbox from '../../components/PickupImageLightbox';
import { getSelectStyles, hasPermission, useTableColors } from '../../Utils';
import EditPickupModal from './EditPickupModal';
import PickupNotes from './PickupNotes';


const attnOptions = [
    { value: 'WITHCOUNT', label: '1+ Samples Pickups' },
    { value: 'ONCALL', label: 'On Call' },
    { value: 'ZERO_FINISHED', label: 'Pickedup 0 samples' },
    { value: "DIFF_SAMPLES", label: "Diff Samples (Received ≠ Picked Up)" }, // ✅ add this
];

const formatDate = (val) => dayjs(val).format("MMM D, YYYY h:mm A");
const FinishedPickups = () => {
    const { isOpen: isViewModalOpen, onOpen: onOpenViewModal, onClose: onCloseViewModal } = useDisclosure();
    const { isOpen: isNoteModalOpen, onOpen: onNoteModalOpen, onClose: onCloseNoterModal } = useDisclosure();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cancelModal, setCancelModal] = useState(false)
    const [confirmRestoreModal, setConfirmRestoreModal] = useState(false)
    const [loadingRestore, setLoadingRestore] = useState(false)

    const toast = useToast()
    const [allPickups, setAllPickups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedPickup, setSelectedPickup] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [error, setError] = useState(null);
    const itemsPerPage = 25;
    const [searching, setSearching] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [attnSelected, setSelectedAttn] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [searchParamsUrl, setSearchParamsUrl] = useSearchParams();
    const [labLocations, setLabLocations] = useState([])
    const [couriers, setCouriers] = useState([]);
    const [searchParams, setSearchParams] = useState({
        pickupLocation: '',
        labLocation: '',
        courier: '',
        startDate: '',
        endDate: '',
        attn: attnSelected.value || null,  // Ensure days is an array
    });

    const coolors = useTableColors()
    const navigate = useNavigate()

    const refresh = useCallback(() => {
        const pageFromUrl = parseInt(searchParamsUrl.get('page')) || 1;
        getPickups(pageFromUrl);
        getLabLocation();
    }, []);

    useEffect(() => {
        const pageFromUrl = parseInt(searchParamsUrl.get('page')) || 1;
        setCurrentPage(pageFromUrl);
        refresh(pageFromUrl);
        getCouriers()
    }, []);

    useEffect(() => {
        refresh()
    }, [refresh]);


    const onInputChange = (e) => {
        const { name, value } = e.target;
        setSearchParams(prevParams => ({
            ...prevParams,
            [name]: value
        }));
    };



    const getPickups = async (page = 1) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getAllPickups(page, itemsPerPage, ['RECEIVED', 'CANCELED']);
            if (response.success) {
                const pickups = response.data.pickups;
                setAllPickups(pickups);
                setCurrentPage(response.data.currentPage);
                setTotalPages(response.data.totalPages);
            } else {
                setError(response.error);
            }
        } catch (error) {
            setError('Failed to load routes');
        }
        setLoading(false);
    };

    const handleSearch = async (currentPage = 1) => {
        setLoading(true);
        try {
            const searchParam = {
                pickupLocationId: searchParams.clientId || null,    // Extract value from react-select
                dropOffLocationId: searchParams.labId || null,    // Extract value from react-select
                courier: searchParams.courierId || null,
                startDate: searchParams.startDate,
                endDate: searchParams.endDate,
                page: currentPage,
                limit: itemsPerPage,
                status: ["RECEIVED", 'CANCELED'],
                attn: attnSelected.value || null,  // Ensure days is an array
            };

            console.log(searchParam)

            setSearching(true)

            const response = await searchPickups(searchParam);
            if (response.success) {
                setAllPickups(response.data.pickups);
                setCurrentPage(response.data.currentPage);
                setTotalPages(response.data.totalPages);
            } else if (response.data.totalItems === 0) {
                setAllPickups([])
            } else {
                toast({
                    title: "Oops !",
                    description: response.error,
                    status: "error",
                    duration: 4000, // duration in milliseconds
                    isClosable: true,
                });

            }
        } catch (error) {
            console.error('Error performing search:', error);
        }
        setLoading(false);
    };

    const clearSearch = () => {
        setSearching(false);
        setSearchParams({
            clientId: '',
            clientName: '',
            labId: '',
            labName: '',
            courierId: '',
            courierName: '',
            startDate: '',
            endDate: ''
        });
        getPickups();
    };

    const handlePageChanges = (page) => {
        setSearchParamsUrl({ page: page.toString() });

        if (searching) {
            handleSearch(page);
        } else {
            getPickups(page);
        }
    };


    const handleUpdatePickup = (updatedPickup) => {
        setAllPickups((prevPickups) =>
            prevPickups.map((pickup) =>
                pickup._id === updatedPickup._id ? updatedPickup : pickup
            )
        );
    };


    // Handle file upload submission
    const handleFileUpload = async () => {
        if (selectedFiles.length === 0) {
            alert('No files selected');
            return;
        }

        console.log(selectedPickup)

        const formData = new FormData();
        selectedFiles.forEach((file) => {
            formData.append('documents', file);
        });
        formData.append('folder', 'couriers-attachements');

        try {

            const response = await uploadPickupAttachements(formData, selectedPickup._id)
            console.log(response)
            if (response.success) {
                if (response.data) {
                    setSelectedPickup(prev => ({
                        ...prev,
                        attachments: response.data.attachments, // make sure backend sends updated pickup
                    }));
                }
                setSelectedFiles([]);

                setSelectedFiles([]); // Clear selected files
                // onCloseViewModal(); // Optionally close the modal
            } else {
                alert(response.error);
            }
        } catch (error) {
            console.error('Error uploading files:', error);
            alert('Error uploading files');
        }
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files); // Convert FileList to array
        const imageFiles = files.filter(file => file.type.startsWith('image/')); // Only keep image files
        setSelectedFiles(imageFiles);

        // Alert if some files are not images
        if (files.length !== imageFiles.length) {
            alert('Only image files are allowed.');
        }
    };

    const getLabLocation = async () => {
        try {
            const response = await fetchLabLocations();
            if (response.success) {
                setLabLocations(response.data)
            }
        } catch (error) {
            setError('Failed to load routes');
        }
    }

    const getCouriers = async () => {
        // Couriers
        try {
            const response = await fetchAllCouriers(1, 99999999);
            if (response.success) {
                setCouriers(response.data.couriers);
            }
        } catch (error) {
            setError('Failed to load couriers');
        }
    }

    const handleExport = async () => {
        try {
            const searchParam = {
                pickupLocationId: searchParams.clientId || null,    // Extract value from react-select
                dropOffLocationId: searchParams.labId || null,    // Extract value from react-select
                courier: searchParams.courierId || null,
                startDate: searchParams.startDate,
                endDate: searchParams.endDate,
                page: currentPage,
                limit: itemsPerPage,
                status: ["RECEIVED", 'CANCELED'],
                attn: attnSelected.value || null,  // Ensure days is an array
            };


            const blob = await exportPickups(searchParam); // optionally pass query string
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'pickups_export.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            console.error('Download failed:', err);
        }
    };

    function getRequirementsIcons(requirements = {}, type) {
        const icons = [];

        if (requirements.hasDocs) icons.push("Docs");
        if (requirements.hasSupplies) icons.push("Supplies");
        if (requirements.requestPhoto) icons.push("Photo");

        return icons.length > 0 ? (
            <Badge size={"xs"} fontSize="xs" colorScheme="gray">({icons.join(', ')})</Badge>
        ) : (
            <Badge size={"xs"} fontSize="xs" colorScheme="gray">-</Badge>
        );
    }

    const handleRestore = async () => {
        setLoadingRestore(true);

        const updatedData = {
            status: "PENDING",
        };

        try {
            const updatedPickup = await updatePickup(updatedData, selectedPickup._id);

            if (updatedPickup.success) {
                toast({
                    title: "Restored",
                    description: "Pickup has been restored successfully",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
                setAllPickups(prev => prev.filter(p => p._id !== selectedPickup._id));
            } else {
                toast({
                    title: "Failed",
                    description: "Failed to restore pickup!",
                    status: "warning",
                    duration: 4000,
                    isClosable: true,
                });
            }
        } catch (error) {
            toast({
                title: "Failed",
                description: "Failed to restore pickup!",
                status: "warning",
                duration: 4000,
                isClosable: true,
            });
            console.log(error);
        } finally {
            setLoadingRestore(false);
            setCancelModal(false); // close confirmation modal
            setConfirmRestoreModal(false);  // close the details modal too
        }
    };



    return (
        <>





            <Box maxW="full" mx="auto">
                {error ? <Text>error</Text> :
                    <>


                        <Box w="100%" overflowX="auto">
                            <VStack spacing={6} align="stretch">
                                <TitleHeader
                                    title={`Finished Pickups`}
                                    onClick={() => setShowFilter(!showFilter)}
                                    buttonText={showFilter ? "Close Filter" : "Filter"}
                                    icon={showFilter ? <CloseIcon /> : <FaLongArrowAltDown />}
                                    thirdButton={true}
                                    thirdButtonText={"Refresh"}
                                    thirdButtonOnClick={refresh}
                                    thirdButtonIcon={<FaSync />}
                                />


                                {showFilter &&
                                    <Center>
                                        <Card w="full" maxW={{ base: '95%', md: '58%' }} bg={coolors.theadBg}>

                                            <Flex
                                                direction={{ base: 'column', md: 'row' }}
                                                wrap="wrap"
                                                p={5}
                                                mb={3}
                                                gap={4}
                                                align="start"
                                            // maxW="100%"
                                            >
                                                {/* Left column */}
                                                <VStack w={{ base: '100%', md: '48%' }} spacing={4} minW={0}>
                                                    <FormControl isRequired w="100%" minW={0}>
                                                        <FormLabel>Pickup Location</FormLabel>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            loadOptions={fetchFacilitiesBySearch}
                                                            defaultOptions
                                                            onChange={(option) =>
                                                                setSearchParams(prev => ({
                                                                    ...prev,
                                                                    clientId: option ? option.value : '',
                                                                    clientName: option ? option.label : '',
                                                                }))
                                                            }
                                                            value={searchParams.clientId ? { value: searchParams.clientId, label: searchParams.clientName } : null}
                                                            placeholder="Search and select a facility"
                                                            closeMenuOnSelect
                                                            isClearable
                                                            styles={getSelectStyles(coolors)}
                                                            classNamePrefix="rs"
                                                        />
                                                    </FormControl>


                                                    {couriers.length > 0 &&
                                                        <FormControl isRequired w="100%" minW={0}>
                                                            <FormLabel>Courier</FormLabel>

                                                            <Select
                                                                classNamePrefix="rs"
                                                                options={couriers?.map(cou => ({
                                                                    value: cou._id,
                                                                    label: `${cou.name} ┃ ${cou.route?.name || "No Route"}`
                                                                }))}
                                                                onChange={(option) =>
                                                                    setSearchParams(prev => ({
                                                                        ...prev,
                                                                        courierId: option ? option.value : '',
                                                                        courierName: option ? option.label : '',
                                                                    }))
                                                                }
                                                                value={
                                                                    searchParams.courierId
                                                                        ? {
                                                                            value: searchParams.courierId,
                                                                            label: couriers.find(f => f._id === searchParams.courierId)?.name || searchParams.courierName,
                                                                        }
                                                                        : null
                                                                }
                                                                placeholder="Select a courier"
                                                                isClearable
                                                                styles={getSelectStyles(coolors)}
                                                            />
                                                        </FormControl>
                                                    }






                                                    <FormControl w="100%" minW={0}>
                                                        <FormLabel>Start Date</FormLabel>
                                                        <Input
                                                            style={{ borderColor: "#999" }}
                                                            name="startDate"
                                                            type="date"
                                                            w="100%"
                                                            value={searchParams.startDate || ''}
                                                            onChange={onInputChange}
                                                        />
                                                    </FormControl>


                                                </VStack>

                                                {/* Right column */}
                                                <VStack w={{ base: '100%', md: '48%' }} spacing={4} minW={0}>
                                                    {labLocations?.length > 0 &&
                                                        < FormControl isRequired w="100%" minW={0}>
                                                            <FormLabel>Lab Account</FormLabel>
                                                            {/* Lab Locations */}
                                                            <Select
                                                                name="labLocationId"
                                                                options={labLocations?.map(loc => ({ value: loc._id, label: loc.name }))}
                                                                placeholder="Select Lab Location"
                                                                onChange={(option) =>
                                                                    setSearchParams(prev => ({
                                                                        ...prev,
                                                                        labId: option ? option.value : '',
                                                                        labName: option ? option.label : '',
                                                                    }))
                                                                }
                                                                styles={getSelectStyles(coolors)}
                                                                classNamePrefix="rs"
                                                            />

                                                        </FormControl>
                                                    }
                                                    <FormControl isRequired w="100%" minW={0}>
                                                        <FormLabel>Attn</FormLabel>
                                                        <Select
                                                            isClearable
                                                            options={attnOptions}
                                                            value={attnSelected}
                                                            onChange={(selectedOptions) => setSelectedAttn(selectedOptions || [])}
                                                            styles={getSelectStyles(coolors)}
                                                            classNamePrefix="rs"
                                                        />
                                                    </FormControl>


                                                    <FormControl w="100%" minW={0}>
                                                        <FormLabel>End Date</FormLabel>
                                                        <Input
                                                            style={{ borderColor: "#999" }}

                                                            name="endDate"
                                                            type="date"
                                                            w="100%"
                                                            value={searchParams.endDate || ''}
                                                            onChange={onInputChange}
                                                        />
                                                    </FormControl>

                                                </VStack>

                                                {/* Buttons */}
                                                <VStack w={{ base: '100%', md: 'auto' }} spacing={2} mt={5} h="100%" justify="space-between" minW={0}>
                                                    <Center>
                                                        <Button colorScheme="blue" size="sm" onClick={() => handleSearch(1)}>
                                                            Search
                                                        </Button>

                                                        <Box flex="1" />

                                                        {searching && (
                                                            <>
                                                                <Button ml={5} colorScheme="red" size="sm" onClick={clearSearch}>
                                                                    Clear
                                                                </Button>
                                                                <Button ml={5} colorScheme="green" size="sm" onClick={handleExport}>
                                                                    Export
                                                                </Button>
                                                            </>
                                                        )}
                                                    </Center>
                                                </VStack>
                                            </Flex>
                                        </Card>
                                    </Center>
                                }

                                {loading ?
                                    <Center mt={"20%"}>
                                        <Loading />
                                    </Center>
                                    :

                                    <>
                                        {allPickups.length > 0 ? (
                                            <Box overflowX="auto" w="100%">
                                                <Table minW={{ base: "800px", md: "100%" }} size="xs">
                                                    <Thead bg={coolors.theadBg}>
                                                        <Tr height={10}>
                                                            <Th fontSize="xs" display={{ base: "none", md: "table-cell" }}>#ID</Th>
                                                            <Th fontSize="xs">Pickup</Th>
                                                            <Th fontSize="xs">Drop</Th>
                                                            <Th fontSize="xs">Courier</Th>
                                                            <Th fontSize="xs" display={{ base: "none", md: "table-cell" }}>Type</Th>
                                                            <Th fontSize="xs" display={{ base: "none", md: "table-cell" }}>Reqs.</Th>
                                                            <Th fontSize="xs" display={{ base: "none", md: "table-cell" }}>Route</Th>
                                                            <Th fontSize="xs">SC</Th>
                                                            <Th fontSize="xs" display={{ base: "none", md: "table-cell" }}>Created</Th>
                                                            <Th fontSize="xs">Finished</Th>
                                                            <Th fontSize="xs" textAlign="right">Actions</Th>
                                                        </Tr>
                                                    </Thead>
                                                    <Tbody>
                                                        {allPickups?.map((pickup, index) => (
                                                            <Tr
                                                                key={pickup._id + "_" + index}
                                                                fontWeight="bold"
                                                                bg={
                                                                    pickup.type === "DropOffOnly"
                                                                        ? coolors.dropOffBg
                                                                        : pickup.type === "Supplies"
                                                                            ? coolors.suppliesBg
                                                                            : pickup.samplesCount === 0
                                                                                ? coolors.pickedBg
                                                                                : index % 2 === 0
                                                                                    ? coolors.rowBgEven
                                                                                    : coolors.rowBgOdd
                                                                }
                                                                borderBottom="2px solid"
                                                                borderColor={coolors.borderColor}
                                                                color={
                                                                    pickup.type === "Supplies"
                                                                        ? coolors.rowHoverColor
                                                                        : pickup.type === "DropOffOnly"
                                                                            ? coolors.textColor
                                                                            : coolors.textColor
                                                                }
                                                                _hover={{
                                                                    bg: coolors.rowHoverBg,
                                                                    color: "white",
                                                                }}
                                                            >
                                                                <Td fontSize="xs" display={{ base: "none", md: "table-cell" }} maxW={1}>
                                                                    <PopoverId
                                                                        fs={"xs"}
                                                                        place="Pickup"
                                                                        index={(currentPage - 1) * itemsPerPage + index}
                                                                        content={pickup._id}
                                                                    />
                                                                </Td>
                                                                <Td pl={4} fontSize="xs">{pickup?.pickupLocation?.name || "N/A"}</Td>
                                                                <Td fontSize="xs">{pickup?.dropOffLocation?.name || "N/A"}</Td>
                                                                <Td fontSize="xs">{pickup?.courier.name}</Td>
                                                                <Td fontSize="xs" display={{ base: "none", md: "table-cell" }}>
                                                                    <Tooltip
                                                                        label={
                                                                            pickup.type === "DropOffOnly"
                                                                                ? "Drop Off"
                                                                                : pickup.type === "Default"
                                                                                    ? "Pickup"
                                                                                    : pickup.type
                                                                        }
                                                                        placement="top"
                                                                    >
                                                                        <Badge
                                                                            cursor="default"
                                                                            colorScheme={
                                                                                pickup.type === "DropOffOnly"
                                                                                    ? "pink"
                                                                                    : pickup.type === "Supplies"
                                                                                        ? "purple"
                                                                                        : "orange"
                                                                            }
                                                                        >
                                                                            {pickup.type === "DropOffOnly"
                                                                                ? "D"
                                                                                : pickup.type === "Default"
                                                                                    ? "P"
                                                                                    : pickup.type === "Supplies"
                                                                                        ? "S"
                                                                                        : ""}
                                                                        </Badge>
                                                                    </Tooltip>
                                                                </Td>

                                                                {/* Requirements */}
                                                                <Td display={{ base: "none", md: "table-cell" }}>{getRequirementsIcons(pickup?.requirements, pickup?.type)}</Td>

                                                                <Td fontSize="xs" display={{ base: "none", md: "table-cell" }}>
                                                                    {pickup.type === "Default" && (
                                                                        <Badge colorScheme={pickup.routeId?.name ? "red" : "green"}>
                                                                            {pickup.routeId?.name || "OC"}
                                                                        </Badge>
                                                                    )}
                                                                </Td>

                                                                <Td fontSize="xs">
                                                                    {pickup.type === "Default" && (
                                                                        <Tooltip
                                                                            label={
                                                                                <>
                                                                                    <div>
                                                                                        <b>Received : </b> {pickup.samplesReceived}
                                                                                    </div>
                                                                                    <div>
                                                                                        <b>Picked Up :</b> {pickup.samplesCount}
                                                                                    </div>
                                                                                    {pickup.samplesReceived > 0 &&
                                                                                        pickup.samplesReceived !== pickup.samplesCount && (
                                                                                            <div>
                                                                                                <b>Difference : </b>{" "}
                                                                                                {pickup.samplesReceived - pickup.samplesCount}
                                                                                            </div>
                                                                                        )}
                                                                                </>
                                                                            }
                                                                            hasArrow
                                                                            placement="top-start"
                                                                            bg={coolors.popoverBg}
                                                                            color={coolors.popoverColor}
                                                                            p={2}
                                                                        >
                                                                            <Badge
                                                                                bg={
                                                                                    pickup.samplesReceived > 0 &&
                                                                                        pickup.samplesReceived / pickup.samplesCount !== 1
                                                                                        ? coolors.sampleZeroBg
                                                                                        : pickup.samplesReceived === 0
                                                                                            ? coolors.sampleZeroBg
                                                                                            : coolors.sampleNonZeroBg
                                                                                }
                                                                                border={
                                                                                    pickup.samplesReceived > 0 &&
                                                                                        pickup.samplesReceived / pickup.samplesCount !== 1
                                                                                        ? "2px solid red"
                                                                                        : ""
                                                                                }
                                                                                color={coolors.sampleTextColor}
                                                                                cursor="pointer"
                                                                            >
                                                                                {"R." +
                                                                                    pickup.samplesReceived +
                                                                                    " | P." +
                                                                                    pickup.samplesCount +
                                                                                    (pickup.samplesReceived > 0 &&
                                                                                        pickup.samplesReceived / pickup.samplesCount !== 1
                                                                                        ? " | D. " +
                                                                                        (pickup.samplesReceived - pickup.samplesCount)
                                                                                        : "")}
                                                                            </Badge>
                                                                        </Tooltip>
                                                                    )}
                                                                </Td>

                                                                <Td fontSize="xs" display={{ base: "none", md: "table-cell" }}>
                                                                    <Text fontSize="xs">
                                                                        {new Date(pickup.createdAt).toLocaleString()}
                                                                    </Text>
                                                                </Td>

                                                                <Td fontSize="xs">
                                                                    {pickup.status === "CANCELED" ? (
                                                                        <Tooltip
                                                                            label={
                                                                                <>
                                                                                    <div>
                                                                                        <b>Reason:</b> {pickup.cancellation?.reason || "N/A"}
                                                                                    </div>
                                                                                    <div>
                                                                                        <b>By:</b> {pickup.cancellation?.by?.firstName || "N/A"}
                                                                                    </div>
                                                                                    <div>
                                                                                        <b>Date:</b>{" "}
                                                                                        {pickup.cancellation?.date
                                                                                            ? new Date(
                                                                                                pickup.cancellation.date
                                                                                            ).toLocaleString()
                                                                                            : "N/A"}
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                            hasArrow
                                                                            placement="top"
                                                                            bg={coolors.popoverBg}
                                                                            color={coolors.popoverColor}
                                                                            p={2}
                                                                        >
                                                                            <Badge colorScheme="red" cursor="pointer"
                                                                                onClick={() => {
                                                                                    setCancelModal(true)
                                                                                    setSelectedPickup(pickup)
                                                                                }}>
                                                                                CANCELED
                                                                            </Badge>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Text fontSize="xs">
                                                                            {pickup.timestamps?.receivedTime
                                                                                ? new Date(
                                                                                    pickup.timestamps.receivedTime
                                                                                ).toLocaleString()
                                                                                : ""}
                                                                        </Text>
                                                                    )}
                                                                </Td>

                                                                <Td fontSize="xs" textAlign="right">
                                                                    <HStack>
                                                                        <Tooltip label="View Details" placement="top">
                                                                            <HStack justifyContent="flex-end" spacing={4}>
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        navigate("/pickups/view/" + pickup._id);
                                                                                    }}
                                                                                    size="xs"
                                                                                    colorScheme="green"
                                                                                >
                                                                                    <ViewIcon />
                                                                                </Button>
                                                                            </HStack>
                                                                        </Tooltip>

                                                                        {hasPermission("updatePickup") && pickup.type === "Default" ? (
                                                                            <Tooltip label="Edit Pickup" placement="top">
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        setSelectedPickup(pickup);
                                                                                        setIsModalOpen(true);
                                                                                    }}
                                                                                    size="xs"
                                                                                    colorScheme="blue"
                                                                                >
                                                                                    <EditIcon />
                                                                                </Button>
                                                                            </Tooltip>
                                                                        ) : (
                                                                            <Tooltip label="Cannot be edited" placement="top">
                                                                                <Button
                                                                                    cursor="default"
                                                                                    disabled
                                                                                    size="xs"
                                                                                    color="#949494"
                                                                                >
                                                                                    <EditIcon />
                                                                                </Button>
                                                                            </Tooltip>
                                                                        )}

                                                                        <Tooltip label="Add/View notes" placement="top">
                                                                            <Button
                                                                                onClick={() => {
                                                                                    setSelectedPickup(pickup);
                                                                                    onNoteModalOpen();
                                                                                }}
                                                                                size="xs"
                                                                                colorScheme="purple"
                                                                            >
                                                                                <FaBook />
                                                                            </Button>
                                                                        </Tooltip>
                                                                        <PickupImageLightbox pickup={pickup} />
                                                                    </HStack>
                                                                </Td>
                                                            </Tr>
                                                        ))}
                                                    </Tbody>
                                                </Table>

                                                <Box mb={10} mt={10}>
                                                    <Pagination
                                                        currentPage={currentPage}
                                                        totalPages={totalPages}
                                                        handlePageChange={handlePageChanges}
                                                    />
                                                </Box>
                                            </Box>
                                        ) : (
                                            <AccessDenied msg="Nothing here yet !" icon="info" />
                                        )}
                                    </>

                                }

                                {selectedPickup &&
                                    <Modal size="6xl" scrollBehavior='inside' isOpen={isViewModalOpen} onClose={onCloseViewModal}>
                                        <ModalOverlay />
                                        <ModalContent>
                                            <ModalHeader>
                                                <HStack spacing={4}>
                                                    <Avatar size="md" name={selectedPickup?.courier?.name} />
                                                    <VStack align="start" spacing={0}>
                                                        <Text fontSize="lg" fontWeight="bold">{selectedPickup?.pickupLocation?.name || selectedPickup?.dropOffLocation?.name}</Text>
                                                        <Text fontSize="sm" color="gray.600">
                                                            {selectedPickup?.pickupLocation?.address?.address1 || ''}
                                                            {selectedPickup?.pickupLocation?.address?.address2 ? `, ${selectedPickup?.pickupLocation?.address?.address2}` : ''}
                                                            {selectedPickup?.pickupLocation?.address?.city ? `, ${selectedPickup?.pickupLocation?.address?.city}` : ''}
                                                            {selectedPickup?.pickupLocation?.address?.state ? `, ${selectedPickup?.pickupLocation?.address?.state}` : ''}
                                                            {selectedPickup?.pickupLocation?.address?.zip ? `, ${selectedPickup?.pickupLocation?.address?.zip}` : ''}
                                                        </Text>
                                                        <Badge colorScheme="blue">{selectedPickup?.status}</Badge>


                                                        <Button colorScheme="gray" onClick={() => {
                                                            const newWindow = window.open('', '', 'width=800,height=1000');
                                                            newWindow.document.write(`
    <html>
      <head>
        <title>Pickup Summary</title>
        <style>
          body { font-family: Arial; padding: 40px; }
          h1 { text-align: center; }
          table { width: 100%; border-collapse: collapse; margin-top: 24px; }
          th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
          th { background: #f0f0f0; }
        </style>
      </head>
      <body>
        <h1>Pickup Summary – ${selectedPickup?.pickupLocation?.name || 'Pickup'}</h1>
        <table>
          <tr><th>Pickup Address</th><td>
            ${selectedPickup?.pickupLocation?.address?.address1 || ''}
            ${selectedPickup?.pickupLocation?.address?.address2 ? `, ${selectedPickup?.pickupLocation?.address?.address2}` : ''}
            ${selectedPickup?.pickupLocation?.address?.city ? `, ${selectedPickup?.pickupLocation?.address?.city}` : ''}
            ${selectedPickup?.pickupLocation?.address?.state ? `, ${selectedPickup?.pickupLocation?.address?.state}` : ''}
            ${selectedPickup?.pickupLocation?.address?.zip ? `, ${selectedPickup?.pickupLocation?.address?.zip}` : ''}
          </td></tr>
          <tr><th>Pickup Date</th><td>${formatDate(selectedPickup?.timestamps?.pickupTime)}</td></tr>
          <tr><th>Courier</th><td>${selectedPickup?.courier?.name || 'N/A'}</td></tr>
          <tr><th>Type</th><td>${selectedPickup?.type || 'N/A'}</td></tr>
          <tr><th>Route</th><td>${selectedPickup?.routeId?.name || 'On Call'}</td></tr>
          <tr><th>Order #</th><td>${selectedPickup?.pickupOrder ?? 'N/A'}</td></tr>
          <tr><th>Request Photo</th><td>${selectedPickup?.requirements?.requestPhoto ? 'Yes' : 'No'}</td></tr>
          <tr><th>Has Supplies</th><td>${selectedPickup?.requirements?.hasSupplies ? 'Yes' : 'No'}</td></tr>
          <tr><th>Has Docs</th><td>${selectedPickup?.requirements?.hasDocs ? 'Yes' : 'No'}</td></tr>
          <tr><th>Received Time</th><td>${formatDate(selectedPickup?.timestamps?.receivedTime)}</td></tr>
          <tr><th>Created At</th><td>${formatDate(selectedPickup?.createdAt)}</td></tr>
          <tr><th>Route Pickup</th><td>${selectedPickup?.isRoutePickup ? 'Yes' : 'No'}</td></tr>
          <tr><th>Created By</th><td>${selectedPickup?.createdBy?.firstName || 'N/A'}</td></tr>
          <tr><th>Receiver</th><td>${selectedPickup?.receivedBy?.firstName || 'N/A'}</td></tr>
          <tr><th>Picked Samples</th><td>${selectedPickup?.samplesCount ?? 'N/A'}</td></tr>
          <tr><th>Received Samples</th><td>${selectedPickup?.samplesReceived ?? 'N/A'}</td></tr>
        </table>
      </body>
    </html>
  `);
                                                            newWindow.document.close();
                                                            newWindow.focus();
                                                            newWindow.print();
                                                            newWindow.close();
                                                        }} leftIcon={<Icon as={FaPrint} />}>
                                                            Print
                                                        </Button>


                                                    </VStack>
                                                </HStack>
                                            </ModalHeader>

                                            <ModalBody>
                                                <SimpleGrid templateColumns={{ base: '1fr', md: '3fr 1fr' }} spacing={8}>
                                                    <Box>
                                                        {/* Pickup Overview */}
                                                        <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                                                            <Heading size="md" mb={4}><Icon as={FaMapMarkerAlt} mr={2} />Pickup Overview</Heading>
                                                            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                                                                <Text><b>Pickup Location:</b> {selectedPickup?.pickupLocation?.name}</Text>
                                                                <Text><b>Drop-off Location:</b> {selectedPickup?.dropOffLocation?.name}</Text>
                                                                <Text><b>Courier:</b> {selectedPickup?.courier?.name}</Text>
                                                                <Text><b>Type:</b> {selectedPickup?.type}</Text>
                                                                <Text><b>Route:</b> {selectedPickup?.routeId?.name || 'On Call'}</Text>
                                                                <Text><b>Order #:</b> {selectedPickup?.pickupOrder}</Text>
                                                            </SimpleGrid>
                                                        </Box>

                                                        {/* Requirements */}
                                                        <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                                                            <Heading size="md" mb={4}><Icon as={FaTasks} mr={2} />Pickup Requirements</Heading>
                                                            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                                                                <Text><b>Request Photo:</b> <Badge colorScheme={selectedPickup?.requirements?.requestPhoto ? 'green' : 'gray'}>{selectedPickup?.requirements?.requestPhoto ? 'Yes' : 'No'}</Badge></Text>
                                                                <Text><b>Has Supplies:</b> <Badge colorScheme={selectedPickup?.requirements?.hasSupplies ? 'green' : 'gray'}>{selectedPickup?.requirements?.hasSupplies ? 'Yes' : 'No'}</Badge></Text>
                                                                <Text><b>Has Docs:</b> <Badge colorScheme={selectedPickup?.requirements?.hasDocs ? 'green' : 'gray'}>{selectedPickup?.requirements?.hasDocs ? 'Yes' : 'No'}</Badge></Text>
                                                            </SimpleGrid>
                                                        </Box>

                                                        {/* Receiver Info */}
                                                        <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                                                            <Heading size="md" mb={4}><Icon as={FaUserCheck} mr={2} />Receiver Info</Heading>
                                                            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
                                                                <Text><b>Name:</b> {selectedPickup?.receivedBy?.firstName}</Text>
                                                                <Text><b>Picked:</b> {selectedPickup?.samplesCount}</Text>
                                                                <Text><b>Received:</b> {selectedPickup?.samplesReceived}</Text>
                                                            </SimpleGrid>
                                                        </Box>

                                                        {/* Notes */}
                                                        <Box mb={8} p={6} borderWidth="1px" borderRadius="lg">
                                                            <Heading size="md" mb={4}><Icon as={FaStickyNote} mr={2} />Pickup Notes</Heading>
                                                            <PickupNotes pickupId={selectedPickup._id} existingNotes={selectedPickup.notes} addNote={false} />
                                                        </Box>
                                                    </Box>

                                                    {/* Right Column */}
                                                    <Box p={6} borderWidth="1px" borderRadius="lg">
                                                        <Heading size="md" mb={4}><Icon as={FaClock} mr={2} />Details</Heading>
                                                        <VStack align="start" spacing={4} fontSize="sm">
                                                            <Text><b>Pickup:</b> {formatDate(selectedPickup.timestamps?.pickupTime)}</Text>
                                                            <Text><b>Received:</b> {formatDate(selectedPickup.timestamps?.receivedTime)}</Text>
                                                            <Text><b>Created:</b> {formatDate(selectedPickup.createdAt)}</Text>
                                                            <Text><b>Route Pickup:</b> <Badge colorScheme={selectedPickup.isRoutePickup ? 'green' : 'red'}>{selectedPickup.isRoutePickup ? 'Yes' : 'No'}</Badge></Text>
                                                            <Text><b>Created By:</b> {selectedPickup?.createdBy?.firstName}</Text>
                                                        </VStack>

                                                        <Box mt={8}>
                                                            <Heading size="md" mb={4}><Icon as={FaPaperclip} mr={2} />Attachments</Heading>


                                                            {hasPermission('uploadAttachments') && (
                                                                <HStack mb={3}>
                                                                    <Input id="file-input" type="file" accept="image/*" multiple display="none" onChange={handleFileChange} />
                                                                    <IconButton icon={<FaCloudUploadAlt />} aria-label="Upload Files" onClick={() => document.getElementById('file-input').click()} />
                                                                    {selectedFiles.length > 0 && (
                                                                        <Button size="sm" onClick={() => handleFileUpload(selectedFiles)}>
                                                                            Submit {selectedFiles.length} file(s)
                                                                        </Button>
                                                                    )}
                                                                </HStack>
                                                            )}


                                                            <SimpleGrid columns={[2, 3]} spacing={4}>
                                                                {selectedPickup?.attachments?.filter(a => !a.deletedAt).map((attachment, index) => (
                                                                    <Box key={index}>
                                                                        <ImageLightbox
                                                                            imageUrl={
                                                                                attachment.fileUrl.startsWith('/uploads/couriers-attachments/')
                                                                                    ? process.env.REACT_APP_IMAGES_LOCAL + attachment.fileUrl.replace('/uploads/couriers-attachments', '/ups/uploads/couriers-attachments')
                                                                                    : process.env.REACT_APP_IMAGES + attachment.fileUrl.replace('/uploads', '/ups/uploads')
                                                                            }

                                                                            altText="Attachment"
                                                                            boxSize="64px"
                                                                            borderRadius="md"
                                                                            boxShadow="md"
                                                                        />
                                                                    </Box>
                                                                ))}
                                                            </SimpleGrid>
                                                        </Box>
                                                    </Box>
                                                </SimpleGrid>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button onClick={onCloseViewModal}>Close</Button>
                                            </ModalFooter>
                                        </ModalContent>
                                    </Modal>
                                }


                                {selectedPickup && selectedPickup.type === 'Default' && (
                                    <>
                                        {/* Edit Pickup */}
                                        <EditPickupModal
                                            isOpen={isModalOpen}
                                            onClose={() => {
                                                setSelectedPickup(null)
                                                setIsModalOpen(false)
                                            }}
                                            pickup={selectedPickup}
                                            onUpdatePickup={handleUpdatePickup}
                                        />
                                    </>

                                )}

                                {selectedPickup &&
                                    <Modal size={"4xl"} scrollBehavior='inside' isOpen={isNoteModalOpen} onClose={onCloseNoterModal}>
                                        <ModalOverlay />
                                        <ModalContent>
                                            <ModalHeader>Add Note to {selectedPickup?.pickupLocation?.name || selectedPickup?.dropOffLocation?.name}
                                                {/* <Badge ml={5} colorScheme={"blue"}>
                                                    {status(selectedPickup.status)}
                                                </Badge> */}
                                            </ModalHeader>
                                            <ModalBody>

                                                <PickupNotes pickupId={selectedPickup._id} existingNotes={selectedPickup.notes} addNote={false} />
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button onClick={onCloseNoterModal}>Close</Button>
                                            </ModalFooter>
                                        </ModalContent>
                                    </Modal>

                                }
                            </VStack >
                        </Box>
                    </>
                }
            </Box >

            {selectedPickup && selectedPickup?.status === "CANCELED" &&
                <>
                    <Modal isOpen={cancelModal} onClose={() => setCancelModal(false)} isCentered>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Cancellation Details</ModalHeader>

                            <ModalBody>
                                <div><b>Reason:</b> {selectedPickup?.cancellation?.reason || "N/A"}</div>
                                <div><b>By:</b> {selectedPickup?.cancellation?.by?.firstName || "N/A"}</div>
                                <div><b>Date:</b> {selectedPickup?.cancellation?.date
                                    ? new Date(selectedPickup?.cancellation.date).toLocaleString()
                                    : "N/A"}
                                </div>
                            </ModalBody>

                            <ModalFooter gap={3}>
                                <Button onClick={() => setCancelModal(false)}>Close</Button>
                                <Button colorScheme="green" onClick={() => setConfirmRestoreModal(true)}>Restore</Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>

                    <Modal isOpen={confirmRestoreModal} onClose={() => setConfirmRestoreModal(false)} isCentered>
                        <ModalOverlay />
                        <ModalContent>
                            <ModalHeader>Restore Pickup</ModalHeader>

                            <ModalBody>
                                Are you sure you want to restore this pickup?
                            </ModalBody>

                            <ModalFooter gap={3}>
                                <Button onClick={() => setConfirmRestoreModal(false)}>No</Button>

                                <Button
                                    colorScheme="red"
                                    onClick={handleRestore}
                                    isLoading={loadingRestore}
                                >
                                    Yes
                                </Button>
                            </ModalFooter>
                        </ModalContent>
                    </Modal>
                </>
            }
        </>
    );
};

export default FinishedPickups;
